import React, { useState } from 'react';
import { Button, Col, Modal, Row } from 'antd';
import {
  useAuth,
  useBraveUpSurveysApi,
  useConfirmClosureData,
  useGetSurveyShow,
} from '@BUP/hooks';
import { useHistory } from 'react-router';
import './styles.css';
import { useTranslation } from 'react-i18next';

const RequestClosureModal = ({ block }) => {
  const history = useHistory();
  const { survey } = useBraveUpSurveysApi();
  const { surveyShow } = useGetSurveyShow(survey);
  const { user } = useAuth();
  const [t] = useTranslation();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModal2Visible, setIsModal2Visible] = useState(false);

  const surveyId = survey?.id;
  const organizationId = user?.organizations?.id;

  const { confirmClosure } = useConfirmClosureData();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [message, setMessage] = useState(null);

  const handleConfirmClosure = async () => {
    const dataConfirm = await confirmClosure({
      data: { organizationId, surveyId, requestClose: true },
    });
    setIsModal2Visible(true);
    setMessage(dataConfirm);
  };

  const requestMessage = message?.message;

  // Funciones para controlar modal
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOkModal2 = () => {
    setIsModal2Visible(false);
  };

  const handleCancelModal2 = () => {
    history.push('/data');
  };

  return (
    <div>
      <Button
        type="primary"
        className="button__closing-request"
        onClick={showModal}
        disabled={
          surveyShow
            ? !!(
                !surveyShow?.active ||
                !surveyShow?.folder_id_questionpro ||
                surveyShow?.requestClose
              )
            : true
        }
        block={block}
      >
        {t('pages.data.activeInstruments.item1Button3Text1')}
        <br />
        {t('pages.data.activeInstruments.item1Button3Text2')}
      </Button>
      <Modal
        className="conditions-modal"
        title={t('pages.data.advanceStatus.modal1Title')}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Row align="space-evenly">
            <Col span={10}>
              <Button
                className="cancel_button"
                type="primary"
                onClick={handleCancel}
              >
                {t('pages.data.advanceStatus.modal1CancelButton')}
              </Button>
            </Col>
            <Col span={10}>
              <Button
                className="conditions__modal_button2"
                type="primary"
                onClick={handleConfirmClosure}
              >
                {t('pages.data.advanceStatus.modal1ConfrimButtonText1')}
                <br />
                {t('pages.data.advanceStatus.modal1ConfrimButtonText2')}
              </Button>

              <Modal
                className="conditions-modal"
                title={t('pages.data.advanceStatus.modal2Title')}
                visible={isModal2Visible}
                onOk={handleOkModal2}
                onCancel={handleCancelModal2}
                footer={[
                  <Row align="space-evenly">
                    <Col span={24} align="center">
                      <Button
                        className="conditions__modal2_button1"
                        type="primary"
                        onClick={handleCancelModal2}
                      >
                        {t('pages.data.advanceStatus.modal2BackButton')}
                      </Button>
                    </Col>
                  </Row>,
                ]}
              >
                <Row align="center">
                  <Col>
                    <p>{requestMessage}</p>
                  </Col>
                </Row>
              </Modal>
            </Col>
          </Row>,
        ]}
      >
        <Row align="center">
          <Col>
            <p>{t('pages.data.advanceStatus.modal1Paragraph1')}</p>
            <p>{t('pages.data.advanceStatus.modal1Paragraph2')}</p>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default RequestClosureModal;
